import { Component, input } from '@angular/core';
import { PageSubheaderComponent } from '../page-subheader/page-subheader.component';
import { PageTitleComponent } from '../page-title/page-title.component';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-page',
  imports: [PageTitleComponent, PageSubheaderComponent, SpinnerComponent],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
  standalone: true,
})
export class PageComponent {
  readonly title = input<string>();
  readonly subheader = input<string>();
  readonly loading = input<boolean>();
  readonly footerText = input<string>();
}
